import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

export const http = axios.create({ baseURL: API });

// Proper SSE parser: events are separated by blank lines; within an event,
// consecutive "data:" lines are joined with "\n" (per the SSE spec).
export async function streamPost(path, body, onDelta, onDone) {
  const res = await fetch(`${API}${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  if (!res.ok || !res.body) throw new Error(`stream failed: ${res.status}`);

  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  let full = "";

  const flushEvent = (eventBlock) => {
    const dataLines = eventBlock
      .split("\n")
      .filter((l) => l.startsWith("data:"))
      .map((l) => l.slice(5).replace(/^ /, ""));
    if (dataLines.length === 0) return true;
    const payload = dataLines.join("\n");
    if (payload === "[DONE]") { onDone?.(full); return false; }
    if (payload.startsWith("[ERROR]")) { throw new Error(payload); }
    full += payload;
    onDelta?.(payload, full);
    return true;
  };

  while (true) {
    const { value, done } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });

    // Split on blank line = event boundary (handles \n\n and \r\n\r\n)
    const parts = buffer.split(/\r?\n\r?\n/);
    buffer = parts.pop() || ""; // last part may be incomplete

    for (const block of parts) {
      const keepGoing = flushEvent(block);
      if (!keepGoing) return full;
    }
  }
  // Flush any trailing event
  if (buffer.trim()) flushEvent(buffer);
  onDone?.(full);
  return full;
}
